module.exports = __webpack_public_path__ + "static/img/gb.d7e70c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/gb.png
// module id = fPSG
// module chunks = 18